import { kyBeforeRequestValidateTokenInterceptor } from '@/@core/services/auth/validateTokenInterceptor';
import { http } from '@aleph-alpha/lib-http';

export const APPLICATION_HTTP_CLIENT = http({
  retry: {
    limit: 1,
    methods: ['get'],
    statusCodes: [404],
  },
  hooks: {
    beforeRequest: [kyBeforeRequestValidateTokenInterceptor],
  },
});
